// extracted by mini-css-extract-plugin
export default {"tripleSpinnerContainer":"loader_tripleSpinnerContainer__TsxBe","tripleSpinner":"loader_tripleSpinner__sHn7z","spin":"loader_spin__xaybQ"};